import React, { FC } from 'react';

import { VIEW_MODE } from '../utils/helpers';
import { UIContextProvider } from './UIContext/UIContextProvider';
import { TemplateContextProvider } from './TemplateContext/TemplateContextProvider';
import { StoreTemplate } from './TemplateContext/TemplateContext';
import { ConfigContextProvider } from './ConfigContext/ConfigContextProvider';
import { ConfigContextShape } from './ConfigContext/ConfigContext';

export interface StoreInitialState {
  viewMode: VIEW_MODE;
  isInfoShown: boolean;
  isEditButtonHidden: boolean;
  template: StoreTemplate;
  config: ConfigContextShape;
}

interface ContextProviderProps {
  initialState: StoreInitialState;
}

export const ContextProvider: FC<ContextProviderProps> = ({ initialState, children }) => {
  const UIContextProviderInitialState = {
    viewMode: initialState.viewMode,
    isEditButtonHidden: initialState.isEditButtonHidden,
    isInfoShown: initialState.isEditButtonHidden,
  };

  const TemplateContextProviderInitialState = {
    template: initialState.template,
  };

  const ConfigContextProviderInitialState = {
    config: initialState.config,
  };

  return (
    <UIContextProvider initialState={UIContextProviderInitialState}>
      <TemplateContextProvider initialState={TemplateContextProviderInitialState}>
        <ConfigContextProvider initialState={ConfigContextProviderInitialState}>{children}</ConfigContextProvider>
      </TemplateContextProvider>
    </UIContextProvider>
  );
};
